import {BaseFormModel} from './base-form-model';
import {TabReport} from './report/tab-report';

export class DashboardWidgetTab extends BaseFormModel<DashboardWidgetTab> {
    id: number;
    title: string;
    type: string;
    report: TabReport;
    maxRows: number;
    durationPart: string;
    durationCount: number;
    comparisonOffsetPart: string;
    comparisonOffsetCount: number;
    sortOrder: number;

    sanitize() {
        this.id = null;
        if (!!this.report) {
            this.report.id = null;

            if (!!this.report.columns) {
                this.report.columns.forEach(c => {
                    c.id = null;
                    if (!!c.columnOne) {
                        c.columnOne.id = null;
                    }
                    if (!!c.columnTwo) {
                        c.columnTwo.id = null;
                    }
                });
            }
            if (!!this.report.baseFilters) {
                this.report.baseFilters.forEach(f => {
                    f.id = null;
                    if (!!f.values) {
                        f.values.forEach(v => v.id = null);
                    }
                });
            }
            if (!!this.report.optionalFilters) {
                this.report.optionalFilters.forEach(f => {
                    f.id = null;
                    if (!!f.values) {
                        f.values.forEach(v => v.id = null);
                    }
                });
            }
            if (!!this.report.sort) {
                this.report.sort.forEach(s => s.id = null);
            }
        }
    }
}
